import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SPUser } from '../models/sp-user';
import { HttpService } from 'src/core/http/http.service';
import { AppConfig } from 'src/config/app-config.service';

@Injectable({
    providedIn: 'root'
})

export class PeoplePickerService {
    constructor(private peoplePickerService: PeoplePickerService, private _http: HttpService) {

    }

    public searchSPUsers(name: string): Observable<SPUser[]> {

        const url = `${AppConfig.settings.authenticationApi}users/SearchUsers?userName=${name}`;
        return this._http.get(url, null, null, false); //, undefined, undefined, false
    }
}